import React from 'react';
import {Button} from 'semantic-ui-react';

const PaginationControl = ({currentPage, totalPages, totalItems, startIndex, endIndex, onPageChange}) => {
    if (totalItems === 0) return null;

    return (
        <div className="table-grid__pagination">
            <div>{startIndex + 1}-{Math.min(endIndex, totalItems)} из {totalItems}</div>
            <Button
                icon
                disabled={currentPage === 1}
                onClick={() => onPageChange(Math.max(1, currentPage - 1))}
            >
                <i className="fa fa-chevron-left"></i>
            </Button>
            <Button
                icon
                disabled={currentPage === totalPages}
                onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
            >
                <i className="fa fa-chevron-right"></i>
            </Button>
        </div>
    );
};

export default PaginationControl;




// WEBPACK FOOTER //
// ./App/pages/massUpload/components/PaginationControl.jsx